/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sreality_Seller_Login_HintInputs */

const cs_sreality_seller_login_hint = /** @type {(inputs: Sreality_Seller_Login_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ověřený Seznam.cz / Sreality login, který makléř na portálu už používá (nebo bude).`)
};

const en_sreality_seller_login_hint = /** @type {(inputs: Sreality_Seller_Login_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verified Seznam.cz / Sreality login this broker already uses (or will use) on the portal.`)
};

/**
* | output |
* | --- |
* | "Verified Seznam.cz / Sreality login this broker already uses (or will use) on the portal." |
*
* @param {Sreality_Seller_Login_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sreality_seller_login_hint = /** @type {((inputs?: Sreality_Seller_Login_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sreality_Seller_Login_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sreality_seller_login_hint(inputs)
	return cs_sreality_seller_login_hint(inputs)
});